import { createFileRoute } from "@tanstack/react-router";

import { Navigate } from "@/lib/router-compat";
export const Route = createFileRoute("/admin/content-intelligence")({
  component: () => <Navigate to="/admin/content-engine" replace />,
});
